import React from 'react';
import SMUserResource from 'resources/SMUserResource';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMSearchListTableRow from 'components/search/SMSearchListTableRow';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMFeatureRoomView from 'components/features/SMFeatureRoomView';
import SMFeatureStaffView from 'components/features/SMFeatureStaffView';
import SMRestClient from 'lib/SMRestClient';
import SMCategorySearchFilterView from 'components/categories/SMCategorySearchFilterView';
import SMUFavoriteListSelectView from 'components/dashboard/users/SMUFavoriteListSelectView';

class SMRankingListView extends React.Component {

  constructor(props) {
    super(props);

    this.canRequest = true;

    this.state = {
      listItems: this.props.rooms,
      latestUpdatedFavoriteList: {},
      targetFavoriteRoom: {},
      isSMUFavoriteListSelectViewOpen: false,
    };
  }

  componentDidMount() {
    SMRenderHelper.addObserverForBaloon();
    SMTrackHelper.criteoList(this.props.currentUser? this.props.currentUser.email : "", this.props.rooms);
  }

  componentDidUpdate(prevProps, prevState) {
  }

  // SMSearchListTableRow delegate
  favoriteDidSelect(favorable, isFavorite, rowIndex) {
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    if (isFavorite) {
      // もしお気に入りに登録されている場合はリスト選択のモーダルを表示
      this.showFavoriteListSelectForm(favorable);
    } else {
      let room = favorable;
      let responseHandler = (data, error, xhr)=>{
        let listItems = this.state.listItems;
        if (error) {
          return;
        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          listItems[rowIndex] = room;
          this.setState({
            listItems: listItems,
            latestUpdatedFavoriteList: data.favorite_list,
          });
        }
      };
      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }

  showFavoriteListSelectForm(room, e){
    if (e) e.preventDefault();
    this.setState({
      targetFavoriteRoom: room,
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  // SMSearchListTableRow delegate
  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  render() {
    let rows = [];
    this.state.listItems.forEach((room, index) => {

      rows.push(
        <SMSearchListTableRow
          key={room.id}
          hasRank={(this.props.currentPage == 1)}
          showBaloon={true}
          room={room}
          noRoomImage={this.props.noRoomImage}
          rowIndex={index}
          canSlide={true}
          delegate={this}
          latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList} />
      );
    });
    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <div className="search-list__head">
                  <div className="search-list__head-wrap">
                    <p className="search-list__head-title">{this.props.title}</p>
                    <span className="search-list__head-number">{this.props.totalCount}件</span>
                  </div>

                  <div className="units-list clear">
                    <ul ref="listContainer" className="row">
                      {rows}
                    </ul>
                  </div>
                  <SMSearchPagerView
                    delegate={this}
                    perPage={this.props.perPage}
                    totalCount={this.props.totalCount}
                    currentPage={this.props.currentPage}
                    links={SMRestClient.parseLinkString(this.props.linkString)} />
                </div>


              </div>
              <div className="col-sm-12 col-md-4 sm-hide">
                <SMCategorySearchFilterView
                  location={this.props.location}
                  event_type={this.props.eventType}
                  capacity={this.props.capacity}
                  amenities={this.props.amenities}
                  eventTypeList={this.props.eventTypeList}
                  capacityList={this.props.capacityList}
                  amenityList={this.props.amenityList}
                  spaceTypeList={this.props.spaceTypeList}
                  priceType={this.props.priceType}
                  />
                <SMFeatureRoomView roomFeatures={this.props.roomFeatures} />
                <SMFeatureStaffView staffFeatures={this.props.staffFeatures} />
              </div>
            </div>
          </div>
        </div>
        <SMUFavoriteListSelectView
          room={this.state.targetFavoriteRoom}
          delegate={this}
          user={this.props.currentUser}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          noFavoriteListImage={this.props.noFavoriteListImage} />
      </div>
    );
  }
}
export default SMRankingListView;



// WEBPACK FOOTER //
// ./app/javascript/components/ranking/SMRankingListView.jsx